(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("FacilityTileViewModel", facilityTileViewModelFactory);

  /** @ngInject */
  function facilityTileViewModelFactory(
    invariant,
    facilityUtils,
    modelUtils,
    messagesStore,
    sortArrayService
  ) {
    function FacilityTileViewModel(deviceJson) {
      this._messagesStoreChangeHandler = null;
      this._propertyMappings = {};
      this._propertyMappings[
        facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA
      ] = "currentTemperature";

      if (typeof deviceJson !== "undefined") {
        this.refresh(deviceJson);
      }
    }

    FacilityTileViewModel.prototype.destroy = function() {
      if (this._messagesStoreChangeHandler) {
        messagesStore.off(
          messagesStore.events.CHANGE,
          this._messagesStoreChangeHandler
        );
      }
    };

    FacilityTileViewModel.prototype.refresh = function(deviceJson) {
      var facilityPoint = facilityUtils.getFacilityPoint(deviceJson);

      invariant(
        facilityPoint,
        "FacilityTileViewModel: device does not contain WASH_FACILITY point."
      );

      this.deviceSerial = deviceJson.deviceKey;
      this.deviceType = deviceJson.deviceType;
      this.pointId = facilityPoint.id;
      this.name = facilityPoint.name;
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      setFeedValue.call(
        this,
        facilityUtils.getFeed(
          facilityPoint,
          facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA
        )
      );

      //todo weather feed read
      this.weatherIcon = "assets/icons/ic_wb_sunny_black_24px.svg";
      this.hasAlarms = false;
      this.hasWarnings = false;

      refreshAlarms.call(this);

      if (!this._messagesStoreChangeHandler) {
        var that = this;
        this._messagesStoreChangeHandler = function() {
          refreshAlarms.call(that);
        };
        messagesStore.on(
          messagesStore.events.CHANGE,
          this._messagesStoreChangeHandler
        );
      }
    };

    FacilityTileViewModel.prototype.refreshDevice = function(deviceJson) {
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();
    };

    FacilityTileViewModel.prototype.refreshDeviceFeed = function(feedJson) {
      setFeedValue.call(this, feedJson);
    };

    return FacilityTileViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[
          this._propertyMappings[feed.reference]
        ] = modelUtils.parseFeedCurrentValue(
          feed.currentValue,
          feed.readingType
        );
      }
    }

    function refreshAlarms() {
      var that = this,
        messages = messagesStore.getMessages(),
        hasMessages = false,
        hasAlarms = false,
        hasWarnings = false,
        excludedList = [
          "CONNECTION_ERROR",
          "ERROR_SETTING_INHIBIT_MODE",
          "COULD_NOT_SIMULATE_COIN",
          "DEAD_RM5_CHANNEL_PIN_ERROR",
          "RESTART_OR_BROWNOUT_OCCURRED",
          "EXTERNAL_PIN_RESET",
          "SOFTWARE_RESET",
          "UNKNOWN_RESET"
        ];

      // This is necessary because we want last state for facility
      messages = messages ? sortArrayService.sortByTime(messages) : messages;

      if (messages !== null && messages.length > 0) {
        hasMessages =
          messages.filter(function(message) {
            if (message.device === that.deviceSerial) {
              switch (true) {
                case message.collapseKey === "alarm" &&
                  !excludedList.includes(message.content):
                  hasAlarms = true;
                  return true;
                case message.collapseKey === "alarm" &&
                  excludedList.includes(message.content):
                  hasAlarms = false;
                  return true;
                case message.collapseKey === "info":
                  hasWarnings = true;
                  return true;
              }
            } else {
              return false;
            }
          }).length > 0;
      }

      this.hasAlarms = hasMessages && hasAlarms;
      this.hasWarnings = hasMessages && hasWarnings;
    }
  }
})();
